import React from "react";

const BackIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
            <path d="M9 11.634C8.33333 12.0189 8.33333 12.9811 9 13.366L13.5 15.9641C14.1667 16.349 15 15.8679 15 15.0981L15 9.90192C15 9.13212 14.1667 8.651 13.5 9.0359L9 11.634Z" fill="white"/>
        </svg>
    );
};

export default BackIcon;
